/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  return <div className="search-result"><a href={props.record.href}><figure><img src={props.record.thumbnail} alt={props.record.title} loading="lazy" /><figcaption><strong>{props.record.title}</strong></figcaption></figure></a></div>;
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? <MDXLayout {...props}><_createMdxContent {...props} /></MDXLayout> : _createMdxContent(props);
}
